export default __webpack_public_path__ + "static/media/particles-web-theme2.6299aee7.svg";